import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { DialogComponent } from '@app/shared/components/dialog/dialog.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TemplateGroupCRUDInputComponent } from '../template-group-crud-input/template-group-crud-input.component';

@Component({
  selector: 'topo-template-group-input-dialog',
  imports: [DialogComponent, TemplateGroupCRUDInputComponent, TranslatePipe],
  templateUrl: './template-group-input-dialog.component.html',
  styleUrl: './template-group-input-dialog.component.scss'
})
export class TemplateGroupInputDialogComponent {
  protected dialogRef = inject<DialogRef>(DialogRef);
  data = inject(DIALOG_DATA);
}
